import ProductsList from "./ProductsList";

const Homepage = () => {
  return (
    <div className="mx-auto px-3 sm:px-3 py-4">
      <p className="font-semibold text-2xl">All Products</p>
      <ProductsList />
    </div>
  );
};

export default Homepage;
